module.exports = __webpack_public_path__ + "assets/images/icon-tile-heart.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-tile-heart.svg
// module id = 24
// module chunks = 0